import { FC, useContext } from 'react'
import {
  CwsButton,
  CwsHeaderShopping,
  CwsHeaderShoppingHeader,
  CwsHeaderShoppingList,
  CwsSection,
} from '@components/cws'
import { getFormattedPrice } from '@utils/price'
import PriceListItem from '@components/common/Header/PriceListItem'
import { useTranslate } from '@hooks/useTranslation'
import { WishlistItem } from '@model/wishlist/WishlistItem'
import { Currency } from '@model/product/PriceInfo'
import { BundleInfo } from '@components/profile/Wishlist/Wishlist'
interface WishlistHeaderProps {
  wishlist: WishlistItem[]
  totalPriceWishlist: number
  currency: Currency
  bundleGroups: Record<string, BundleInfo[]>
  setTotalWishlistPrices: (itemSku: string, price: number) => void
  openLegacyWishlist: () => void
  freeProducts: Record<string, number | string[]>
}
export const HeaderWishlist: FC<WishlistHeaderProps> = ({
  wishlist,
  totalPriceWishlist,
  currency,
  bundleGroups,
  setTotalWishlistPrices,
  openLegacyWishlist,
  freeProducts,
}) => {
  const { translate } = useTranslate()

  const wishlistItems = wishlist.length > 3 ? wishlist.slice(0, 3) : wishlist

  return (
    <CwsHeaderShopping>
      <CwsHeaderShoppingHeader
        title={translate('wishlist.tile.wishlist')}
        icon="wishlist"
        count={
          wishlist?.reduce((acc, cur) => {
            return cur.quantityDesired + acc
          }, 0) ?? 0
        }
      />

      <CwsHeaderShoppingList
        moreItemsLabel={wishlist.length > 3 ? translate('wishlist.more.items', { count: wishlist.length - 3 }) : ''}
        price={getFormattedPrice(totalPriceWishlist, currency)}
      >
        {wishlistItems?.map((item) =>
          item.product && item.quantityDesired ? (
            <PriceListItem
              bundleGroups={bundleGroups}
              key={item.id}
              item={item}
              currency={currency}
              quantityProductIsFree={(freeProducts[item.product.sku] as number) || 0}
              isWishlist
              setTotalCartPrices={setTotalWishlistPrices}
              isMobile
            />
          ) : null
        )}
      </CwsHeaderShoppingList>
      <CwsSection className="cws-mt-xs" variant="div">
        <CwsButton
          width="fluid"
          onClick={() => {
            openLegacyWishlist()
          }}
        >
          {translate('wishlist.view.all')}
        </CwsButton>
      </CwsSection>
    </CwsHeaderShopping>
  )
}
